var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat204(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_204"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_204",
    "data-name": 204,
    className: "cls-2",
    d: "M44,96.86c-7.43-2.8-11-9.76-12.16-12.17C18.28,57.91,57.31-1.41,65.86,2c2.53,1,.1,6.53,0,29.2C65.69,71,73,86.59,63.43,94.42,58.16,98.72,49.79,99.05,44,96.86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat204);
export default __webpack_public_path__ + "static/media/cat_204.3b48a1e2419eebdc51f0ccb08ce27d8d.svg";
export { ForwardRef as ReactComponent };